import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { StockReportsService } from 'src/app/erp/services/reports/stockreports/stockreports.service';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/shared/constants';
import { catchError, of } from 'rxjs';
interface LoginResponse {
  status: number;
  body: any; // Replace with a specific User interface if known
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: FormGroup;
  forgotPasswordForm: FormGroup;
  @ViewChild('employeeCodeInput') employeeCodeInput: ElementRef;

  logoImageBase64: string = '';
  private baseUrl: string = 'https://s3service.sconexsoft.com/s3bucket/presigned-url';
  s3AssetFolder: string = '';
  bucketName: string = '';

  constructor(
    private fb: FormBuilder,
    private route: Router,
    private loginService: LoginService,
    private stockReportService: StockReportsService,
    private http: HttpClient
  ) {
    this.loginForm = this.fb.group({
      LocationID: [null],
      EmployeeCode: [null, Validators.required],
      Password: [null, Validators.required],
      FinancialYear: [null],
    });

    this.forgotPasswordForm = this.fb.group({
      OTP: [null],
      currentPassword: [null, Validators.required],
      newPassword: [null, Validators.required],
      confirmPassword: [null, Validators.required],
      LocationID: [null, Validators.required],
      CreateUserID: null,
      EmployeeCode: null
    });
  }

  itemList: any = [];
  locationCodes: any = [];
  financialYears: any = [];

  showSendOTP: boolean = true;
  otpSuccessMss: boolean = false;
  confirmOTP: boolean = false;
  changePasswodForm: boolean = false;

  loginObject: any = {
    LocationID: null,
    EmployeeCode: null,
    Password: null,
    YearNo: null
  };
  showPassword: boolean = false;

  ngOnInit() {
    if (this.loginService.getToken()) {
      this.route.navigate(['/home']);
    } else {
      this.getLocationCodes();
      this.route.navigate(['/login']);
      this.loginService.logout();
    }
  }

  ngAfterViewInit() {
    if (this.employeeCodeInput) {
      this.employeeCodeInput.nativeElement.focus();
    }
  }

  clearPasswordFrom() {}

  forgotPasswordSendOPT() {
    if (!this.forgotPasswordForm.valid) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please fill all required fields for OTP'
      });
      return;
    }
    let inputData = {
      LocationID: this.forgotPasswordForm.value.LocationID,
      EmployeeCode: this.forgotPasswordForm.value.EmployeeCode,
    };
    this.loginService.generateForgotPasswordOTP(inputData).subscribe(res => {
      if (res) {
        this.confirmOTP = true;
        this.otpSuccessMss = true;
        this.showSendOTP = false;
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to send OTP: ' + (error.message || 'Unknown error')
      });
    });
  }

  confirmForgotPasswordOTP() {
    let inputData = {
      LocationID: this.forgotPasswordForm.value.LocationID,
      EmployeeCode: this.forgotPasswordForm.value.EmployeeCode,
      OTP: this.forgotPasswordForm.value.OTP
    };
    this.loginService.confirmForgotPasswordOTP(inputData).subscribe(res => {
      if (res) {
        this.confirmOTP = false;
        this.otpSuccessMss = false;
        this.showSendOTP = false;
        this.changePasswodForm = true;
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to confirm OTP: ' + (error.message || 'Unknown error')
      });
    });
  }

  savePassword() {
    let newPassword = this.forgotPasswordForm.value.newPassword;
    let confirmPassword = this.forgotPasswordForm.value.confirmPassword;
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'New Password and Confirm Password should match'
      });
      return;
    }
    this.loginService.savePassword(this.forgotPasswordForm.value).subscribe(res => {
      if (res.status === 201) {
        this.resetPasswordFrom();
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Password changed successfully'
        });
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to save password: ' + (error.message || 'Unknown error')
      });
    });
  }

  resetPasswordFrom() {
    this.forgotPasswordForm = this.fb.group({
      OTP: [null],
      currentPassword: [null, Validators.required],
      newPassword: [null, Validators.required],
      confirmPassword: [null, Validators.required],
      LocationID: [null, Validators.required],
      CreateUserID: this.user?.EmployeeCode,
      EmployeeCode: this.user?.EmployeeCode
    });
  }

  getLocationCodes() {
    this.loginService.getLocationCodes().subscribe({
      next: (res) => {
        if (!res || res.length === 0) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No location codes available'
          });
          return;
        }
        this.itemList = [];
        this.locationCodes = res.map(item => ({
          ID: item.LocationID.toString(), // Normalize to string
          Code: item.Name,
          S3AssetFolder: item.S3AssetFolder || '',
          S3BucketName: item.S3BucketName || ''
        }));
        console.log('Location Codes:', this.locationCodes);

        if (this.locationCodes.length === 1) {
          this.loginForm.patchValue({ LocationID: this.locationCodes[0].ID });
          this.getFinancialYears();
        }
        this.loginForm.get('LocationID')?.valueChanges.subscribe((locationId: string) => {
          const selectedLocation = this.locationCodes.find(loc => loc.ID === locationId);
          if (selectedLocation) {
            this.s3AssetFolder = selectedLocation.S3AssetFolder;
            this.bucketName = selectedLocation.S3BucketName;
            console.log('Selected Location:', selectedLocation);
          } else {
            console.error('Selected location not found for ID:', locationId);
            this.loginForm.patchValue({ LocationID: null });
            this.logoImageBase64 = '';
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Selected location not found'
            });
          }
        });
      },
      error: (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch location codes: ' + (error.message || 'Unknown error')
        });
        this.logoImageBase64 = '';
      }
    });
  }


  getFinancialYears() {
    const locationCode = this.loginForm.value.LocationID;
    if (!locationCode) return;
    this.loginService.getFinancialYears(locationCode).subscribe(res => {
      this.itemList = [];
      if (res) {
        res.forEach(item => {
          const fromYear = new Date(item.YearFrom);
          const toYear = new Date(item.YearTo);
          const finYear = fromYear.getFullYear() + ' - ' + toYear.getFullYear();
          this.itemList.push({
            ID: item.YearNo,
            Code: finYear,
            YearFrom: fromYear
          });
        });

        this.financialYears = this.itemList.sort((a, b) => b.YearFrom - a.YearFrom);

        if (this.financialYears.length > 0) {
          this.loginForm.patchValue({ FinancialYear: this.financialYears[0].ID });
        }
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch financial years: ' + (error.message || 'Unknown error')
      });
    });
  }

  async fetchLogoImage() {
    if (!this.s3AssetFolder || !this.bucketName) {
      console.error('Missing S3AssetFolder or S3BucketName', {
        s3AssetFolder: this.s3AssetFolder,
        bucketName: this.bucketName
      });
      this.logoImageBase64 = '';

      return;
    }

    const cleanFolder = this.s3AssetFolder.replace(/^\/+/, '');
    const fileName = `${cleanFolder}Logo.jpeg`.replace(/\/+/g, '/');
    const apiUrl = `${this.baseUrl}?fileName=${encodeURIComponent(fileName)}&bucketName=${encodeURIComponent(this.bucketName)}&operation=download`;

    await this.http.get(apiUrl, { responseType: 'text' })
      .pipe(
        catchError((error) => {

          console.warn('Failed to fetch presigned URL from S3 (non-blocking):', error);
          this.logoImageBase64 = '';
          return of('');
        })
      )
      .subscribe((presignedUrl: string) => {
        if (!presignedUrl || !presignedUrl.startsWith('https://')) {
          this.logoImageBase64 = '';
          return;
        }
        this.http.get(presignedUrl, { responseType: 'blob' })
          .pipe(
            catchError((error) => {
              console.warn('Failed to fetch logo image from presigned URL (non-blocking):', error);
              this.logoImageBase64 = '';
              return of(new Blob());
            })
          )
          .subscribe((blob: Blob) => {
            if (!blob || blob.size === 0 || blob.type !== 'image/jpeg') {
              this.logoImageBase64 = '';
              return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
              this.logoImageBase64 = reader.result as string;
            };
            reader.onerror = (error) => {
              console.warn('FileReader error (non-blocking):', error);
              this.logoImageBase64 = '';
            };
            reader.readAsDataURL(blob);
          });
      });
  }
  itemsData: any[] = [];
  user: any;
  getItemsData() {
    this.user = this.loginService.getUser();
    this.itemsData = [];
    const inputObj = {
      LocationID: 1,
      CategoryId: 0,
    };
    this.stockReportService.getClosingStock(inputObj).subscribe(
      result => {
        if (result.body.length > 0) {
          this.itemList = [];
          result.body.forEach(item => {
            this.itemList.push({
              ID: item.ItemID,
              Code: item.DisplayText
            });
          });
          this.itemsData = this.itemList;
        }
      });
  }


  login() {
    if (!this.loginForm.invalid) {
      this.loginObject.LocationID = this.loginForm.value.LocationID;
      this.loginObject.EmployeeCode = this.loginForm.value.EmployeeCode;
      this.loginObject.Password = this.loginForm.value.Password;
      this.loginObject.YearNo = this.loginForm.value.FinancialYear;
      this.loginService.login(this.loginObject).subscribe(res => {
        if (res.status === 200) {
          const user = res.body;
          this.loginService.storeUserData(user);
          this.loginForm.patchValue({
            LocationID: null,
            Password: null,
            EmployeeCode: null,
            FinancialYear: null
          });
          location.reload();
          this.getItemsData();
          // this.hrmslogin();
        } else {
          Swal.fire('Login Fail.', 'Please check email and password.', 'error');
        }
      }, error => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error
        });
      });
    }
     else {
      Swal.fire('Oops..', 'Please fill all fields.', 'error');
    }
  }

  // login() {
  //   if (this.loginForm.invalid) {
  //     Swal.fire('Oops..', 'Please fill all fields.', 'error');
  //     return;
  //   }

  //   // Populate loginObject with form values
  //   this.loginObject.LocationID = this.loginForm.value.LocationID;
  //   this.loginObject.EmployeeCode = this.loginForm.value.EmployeeCode;
  //   this.loginObject.Password = this.loginForm.value.Password;
  //   this.loginObject.YearNo = this.loginForm.value.FinancialYear;

  //   // Call both login and hrmslogin concurrently
  //   forkJoin({
  //     login: this.loginService.login(this.loginObject).pipe(
  //       catchError((error) => of({ status: 0, body: null, error: error.message || 'ERP login failed' }))
  //     ),
  //     hrmslogin: this.loginService.hrmslogin({
  //       employeeCode: this.loginObject.EmployeeCode,
  //       password: this.loginObject.Password,
  //       locationId: this.loginObject.LocationID,
  //       yearNo: this.loginObject.YearNo
  //     }).pipe(
  //       catchError((error) => of({ status: 0, body: null, error: error.message || 'HRMS login failed' }))
  //     )
  //   }).subscribe({
  //     next: ({ login, hrmslogin }: { login: LoginResponse; hrmslogin: LoginResponse }) => {
  //       // Handle ERP login response
  //       if (login.status === 200) {
  //         const user = login.body;
  //         this.loginService.storeUserData(user);
  //         this.getItemsData();
  //         console.log('ERP Login success');
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'ERP Login Failed',
  //           // text: login.error || 'Please check email and password for ERP login.'
  //         });
  //       }

  //       // Handle HRMS login response
  //       if (hrmslogin.status === 200) {
  //         const hrmsUser = hrmslogin.body;
  //         this.loginService.storeHrmsData(hrmsUser);
  //         console.log('HRMS Login success');
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'HRMS Login Failed',
  //           // text: hrmslogin.error || 'Please check email and password for HRMS login.'
  //         });
  //       }

  //       // If both calls are successful, reset form and navigate
  //       if (login.status === 200 && hrmslogin.status === 200) {
  //         this.loginForm.patchValue({
  //           LocationID: null,
  //           Password: null,
  //           EmployeeCode: null,
  //           FinancialYear: null
  //         });
  //         this.route.navigate(['/home']);
  //       }
  //     },
  //     error: (error) => {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Error',
  //         text: `Login failed: ${error.message || 'Unknown error'}`
  //       });
  //     }
  //   });
  // }

  // hrmslogin() {
  //   if (this.loginForm.invalid) {
  //     Swal.fire('Oops..', 'Please fill all fields.', 'error');
  //     return;
  //   }

  //   // Populate loginObject with form values
  //   const hrmsLoginObject = {
  //     LocationID: this.loginForm.value.LocationID,
  //     EmployeeCode: this.loginForm.value.EmployeeCode,
  //     Password: this.loginForm.value.Password,
  //     YearNo: this.loginForm.value.FinancialYear
  //     // YearNo is not included as it's not required by hrmslogin API
  //   };

  //   // Perform HRMS login
  //   this.loginService.hrmslogin(hrmsLoginObject).subscribe({
  //     next: (res: LoginResponse) => {
  //       if (res.status === 200) {
  //         const user = res.body;
  //         this.loginService.storeHrmsData(user);
  //         this.loginForm.patchValue({
  //           LocationID: null,
  //           Password: null,
  //           EmployeeCode: null,
  //           FinancialYear: null
  //         });
  //         this.getItemsData();
  //         console.log('HRMS Login success');
  //       } else {
  //         Swal.fire('HRMS Login Fail.', 'Please check email and password.', 'error');
  //       }
  //     },
  //     error: (error) => {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Error',
  //         text: `HRMS Login failed: ${error.message || 'Unknown error'}`
  //       });
  //     }
  //   });
  // }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
